import { formatNumberWithSpaces } from '@shared/lib/formatNumberWithSpaces';
import { ProjectInfo } from '@entities/clients';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface ProjectsCellProps {
  projects: ProjectInfo[] | null;
  namesOnly?: boolean;
}

export const ProjectsCell = ({ projects, namesOnly = false }: ProjectsCellProps) => {
  if (!projects?.length) return;

  if (namesOnly) {
    return (
      <div {...stylex.props(styles.projects)}>
        {projects.map(({ project }) => (
          <span key={project?.id ?? project?.name}>{project?.name}</span>
        ))}
      </div>
    );
  }

  const getTotalAmount = () =>
    projects.reduce((total, project) => {
      return total + Number(project.amount);
    }, 0);

  const getProjectContent = (name?: string, amount?: string | number, isTotal?: boolean) => (
    <div key={`${name}-${amount}`} {...stylex.props(styles.project)}>
      <span>{name}</span>
      <div {...stylex.props(styles.divider)} />
      {amount && (
        <span {...stylex.props(styles.amount, isTotal && styles.total)}>{formatNumberWithSpaces(amount)} ₽</span>
      )}
    </div>
  );

  return (
    <div {...stylex.props(styles.projects)}>
      {projects?.map(({ project, amount }) => getProjectContent(project?.name, amount))}
      {projects?.length > 1 && (
        <>
          <div {...stylex.props(styles.totalDivider)} />
          {getProjectContent('Итого:', getTotalAmount(), true)}
        </>
      )}
    </div>
  );
};
